// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Store Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackLinkParameters extends TrackEventBaseParameters {}

const trackLink = (parameters: TrackLinkParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "link_clicked", ...parameters }, options);
};

export default trackLink;
